import { render } from "./WebsiteConfig.vue?vue&type=template&id=66b0384a&scoped=true"
import script from "./WebsiteConfig.vue?vue&type=script&lang=js"
export * from "./WebsiteConfig.vue?vue&type=script&lang=js"

import "./WebsiteConfig.vue?vue&type=style&index=0&id=66b0384a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66b0384a"]])

export default __exports__